import {
  Component,
  OnInit
} from '@angular/core';
import { ConfigurationService } from '@sondermind/configuration';
import { BreakpointsService } from '@sondermind/formlib';
import { IrisButtonTypes } from '@sondermind/iris/button';
import { SegmentService } from '@sondermind/segment';
import { UserSystemInfoService } from '@sondermind/utilities/services';
import { FlowsIntakeSegmentEvents, IFlowsIntakeSegmentEvents } from '../../../models/flows-intake-segment-schema.interface';

@Component({
  selector: 'mobile-app-cta',
  templateUrl: './mobile-app-cta.component.html',
  styleUrls: ['./mobile-app-cta.component.scss']
})
export class MobileAppCTA implements OnInit {
  APPLE_SONDERMIND_APP_LINK = 'https://apps.apple.com/app/apple-store/id1475263597?pt=127447317&ct=MatchFlowReadinessCTA&mt=8';
  ANDROID_SONDERMIND_APP_LINK = 'https://play.google.com/store/apps/details?id=com.sondermind.client&utm_source=appstore&utm_medium=cta&utm_campaign=MatchFlowReadinessCTA';

  irisButtonTypes = IrisButtonTypes;

  isAndroid: boolean = false;

  constructor(
    public breakpointsService: BreakpointsService,
    private userSystemInfo: UserSystemInfoService,
    private configurationService: ConfigurationService,
    private segmentService: SegmentService<IFlowsIntakeSegmentEvents>
  ) { }

  ngOnInit(): void {
    this.isAndroid = this.userSystemInfo.isAndroid();
  }

  handleClick(): void {
    this.segmentService.track(
      FlowsIntakeSegmentEvents.MOBILE_APP_CTA_CLICKED,
      { appStore: this.isAndroid ? 'android' : 'iPhone' }
    ).catch(() => { });
  }

  get urlBase(): string {
    return this.configurationService.env.urlBase;
  }
}
